var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title"},[_c('div',{staticClass:"back",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("../assets/images/home/back.png")}})]),_c('div',{staticClass:"auto-hide"},[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}})]),_c('div',{staticClass:"text-right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }